import React from 'react';

import { avatarDefault } from '@/assets/images';
import { Stack } from '@/components/layout';
import { Image, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type Props = { name: string; avatarUri?: string; tablet?: boolean };

export function ProfileIdentity({ name, avatarUri, tablet = false }: Props) {
  const { scale } = useScaling();
  const styles = useStyles();
  const avatarSize = scale(100);

  return (
    <Stack align="center" style={[styles.root, tablet ? styles.tabletRoot : null]}>
      <Stack
        style={[
          styles.avatarFrame,
          {
            width: avatarSize + scale(4),
            height: avatarSize + scale(4),
            borderRadius: (avatarSize + scale(4)) / 2,
          },
        ]}>
        <Image
          source={avatarUri ? { uri: avatarUri } : avatarDefault}
          width={avatarSize}
          height={avatarSize}
          circular
          resizeMode="cover"
        />
      </Stack>
      <Text variant="Font Guardian App/Heading/Heading H6 18px" style={styles.name}>
        {name}
      </Text>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  root: {
    width: '100%',
    gap: scale(8),
    paddingVertical: scale({ phone: 0, tablet: 8 }),
  },
  tabletRoot: {
    paddingHorizontal: scale(12),
    borderRadius: scale(12),
    backgroundColor: colors['0'],
  },
  avatarFrame: {
    borderWidth: scale(2),
    borderColor: colors['0'],
    backgroundColor: colors['2'],
    justifyContent: 'center',
    alignItems: 'center',
  },
  name: { width: '100%', color: guardianColors['10'], textAlign: 'center' },
}));
